import React, { useEffect, useState } from 'react'
import API from 'util/onboardApi'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Slide } from '@material-ui/core';
import ActionsTable from "components/ActionsTable/TableList";
import ContainerHeader from 'components/ContainerHeader'
import SnackBar from 'components/SnackBar'
import { LinearProgress as LinearProgres } from "@material-ui/core";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
    });

const Payouts = (props) => {

    const [snackBar, setSnackBar] = useState({
        open: false,
        message: "",
        type: "error",
    });

    const [loading, setLoading] = useState(false);
    const [payoutList, setPayoutList] = useState();
    const [dialog, setDialog] = useState({open:false, fullWidth:true, content:null, header:'', agreeBtnTxt:'', disAgreeBtnTxt:'', disableSubmit:false, type:'', callback:null});

    useEffect(()=>{
        getUsersList();
    },[])


    const getUsersList = ()=>{
        setLoading(true);
        API.get("payoutsList")
        .then((res) => {
            setPayoutList(res.data.data.payouts)
        })
        .catch((err) => {
            setSnackBar({
                open: true,
                message: err?.response?.data?.msg,
                type: "error",
            })
        }).finally(()=>{
            setLoading(false)
        })
    }
    const makePayment = (payout)=>{
        setLoading(true);
        API.put("makePayment",{applied_job_id: payout?.applied_job_id?.value})
        .then((res) => {
            getUsersList();
            handleDialogClose();
        })
        .catch((err) => {
            setSnackBar({
                open: true,
                message: err?.response?.data?.msg,
                type: "error",
            })
        }).finally(()=>{
            setLoading(false)
        })
    }  
    const confirmPayment = (payout)=>{
        setDialog({
            open:true,
            header:`MaKe Payment`,
            content: `Are you sure you want to proceed with the payment of RS ${payout?.payout?.value} to ${payout?.name?.value} ?`,
            submitBtnLabel:'Confirm',
            disAgreeBtnTxt:'Cancel',
            userData: payout,
            callback:makePayment,
            
        })
    } 
    const handleDialogClose = ()=>{
        setDialog({
            open:false,
            content:'',
            header:'',
            agreeBtnTxt:'',
            disAgreeBtnTxt:'',
            type:'',
            location:null,
            callback:null
        });
    }
    return (
        <>
            <ContainerHeader title={`User Payouts`} />
            { loading &&  <div className='w-100'><LinearProgres color="primary" /></div> }
            {
                payoutList && 
                <ActionsTable
						tableHeading={''}
						table={payoutList}
						actions={true}
                        makePayment={confirmPayment}
		        />
            }
             <Dialog
				open={dialog.open}
				TransitionComponent={Transition}
				keepMounted
				fullWidth
				maxWidth='md'
				onClose={handleDialogClose}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<LinearProgress style={{visibility:props.showProgress ? 'visible' : 'hidden'}} color="primary" />
				<DialogTitle id="alert-dialog-slide-title" sx={{ borderBottom: "1px solid red" }} style={{ textAlign: "center" }}>{dialog.header}</DialogTitle>
				<DialogContent>
					{dialog.content}
				</DialogContent>
				<DialogActions>
					{dialog.submitBtnLabel && 
						<Button variant="outlined"  color="primary" onClick={() => { dialog.callback(dialog.userData)}} disabled={dialog.disableSubmit} > {dialog.submitBtnLabel} </Button>}						
					<Button variant="outlined"  color="secondary" onClick={handleDialogClose}> Close</Button>
				</DialogActions>
			</Dialog>
            <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar({ open: false, message: "" });
                }}
            />
        </>
    )

}

export default Payouts;